export default __webpack_public_path__ + "static/media/dress3.7479253e.jpeg";